/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import HorizontalDivider from 'DesignSystem/HorizontalDivider/index'
import MfaToken from './MfaToken/index'
import React from 'react'
import Ref from './Ref/index'
import Users from './Users/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/ChooseLocation/Support/Audit/Content"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<MfaToken
  viewPath={`${viewPath}/MfaToken`}
/>
<HorizontalDivider
  viewPath={`${viewPath}/HorizontalDivider`}
 marginTop={dtSpaceS}
/>
<Users
  viewPath={`${viewPath}/Users`}
/>
<Ref
  viewPath={`${viewPath}/Ref`}
/>
{children}
</React.Fragment>)
}